// extracted by mini-css-extract-plugin
module.exports = {"btn":"BackButton_btn__22UPX","label":"BackButton_label__7d-to"};